import { useEffect, useState } from "react";
import UserGrowth from "./userRevenueGrowth";
import SubscriptionDistribution from "./subscriptionsDistribution";
import Transactions from "./transactions";
import PopularCourts from "./popularCourts";
import { FaUsers } from "react-icons/fa";
import { TbCalendarDollar } from "react-icons/tb";
import { MdOutlineSportsTennis } from "react-icons/md";
import { GiTennisCourt } from "react-icons/gi";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchRevenue,
  fetchUsersList,
  courtFetch,
  fetchGames,
} from "../../api/endpoint";
import { saveRevenueData } from "../../store/slice/revenueSlice";
import { saveUsersData } from "../../store/slice/usersSlice";
import { saveCourtsData } from "../../store/slice/courtsSlice";
import { saveGamesData } from "../../store/slice/gamesSlice";
import toast from "react-hot-toast";
import axios from "axios";

const Home = () => {
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state?.login);
  const { revenue } = useSelector((state) => state?.revenue);
  const [loading, setLoading] = useState(false);
  const [totalCourts, setTotalCourts] = useState(0)
  const [totalUsers, setTotalUsers] = useState(0)
  const [totalGames, setTotalGames] = useState(0)

  useEffect(() => {
    fetchUsers();
    getRevenue();
    fetchCourts();
    fetchGamesList();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchUsersList, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      const users = response.data?.content;
      const userData = users?.map((user) => ({
        id: user?.id,
        name: user?.name,
        email: user?.email,
        mobNo: user?.mobileNumber,
      }));
      setTotalUsers(response?.data?.totalElements)
      dispatch(saveUsersData(userData));
    } catch (error) {
      toast.error("Failed to fetch users");
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const getRevenue = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchRevenue, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      setLoading(false);
      dispatch(saveRevenueData(response?.data));
    } catch (error) {
      console.error("Error fetching revenue data:", error);
      toast.error("Error fetching revenue data");
    }
  };

  const fetchCourts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(courtFetch, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      setTotalCourts(response?.data?.totalElements)
      dispatch(saveCourtsData(response?.data?.content));
    } catch (error) {
      console.error("Error fetching courts:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchGamesList = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchGames, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      setTotalGames(response?.data?.totalElements)
      dispatch(saveGamesData(response?.data?.content));
    } catch (error) {
      // toast.error("Error Fetching Games");
      console.error("Error Fetching Games", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-md-2 px-1 py-md-2 py-1">
      <h3 className="mb-3">Dashboard</h3>
      <div className="row" style={{ "--bs-gutter-x": "2rem", "--bs-gutter-y": "2rem", marginBottom: '2rem' }}>
        <div className="col-md-6 col-lg-3">
          <div className="card h-100 shadow rounded-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="card-title">{totalUsers}</h4>
                  <div>Total Users</div>
                </div>
                <FaUsers size={60} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="card h-100 shadow rounded-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="card-title">{totalGames}</h4>
                  <div>Number of Games</div>
                </div>
                <MdOutlineSportsTennis size={60} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="card h-100 shadow rounded-4">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <h4 className="card-title">{totalCourts}</h4>
                  <div>Number of Courts</div>
                </div>
                <GiTennisCourt size={60} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="card h-100 shadow rounded-4">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <h5 className="card-title">{revenue?.paidUsers}</h5>
                  <p>Ongoing Subscriptions</p>
                </div>
                <TbCalendarDollar size={60} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{ "--bs-gutter-x": "2rem", "--bs-gutter-y": "2rem", marginBottom: '2rem' }}>
        <div className="col-md-6">
          <UserGrowth />
        </div>
        <div className="col-md-6">
          <SubscriptionDistribution />
        </div>
      </div>
      <div className="row" style={{ "--bs-gutter-x": "2rem", "--bs-gutter-y": "2rem", marginBottom: '2rem' }}>
        <div className="col-md-6">
          <Transactions />
        </div>
        <div className="col-md-6">
          <PopularCourts />
        </div>
      </div>
      {/* {loading && <Loader/>} */}
    </div>
  );
};

export default Home;
